import "mapbox-gl/dist/mapbox-gl.css";

import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Admin from "./Admin";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// import dotenv from 'dotenv'

// dotenv.config()
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/address/:addressSearch",
    element: <App />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/property/:propertyId",
    element: <App />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/search/:query",
    element: <App />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/property-manager/:propertyManager",
    element: <App />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/organize",
    element: <App organize={true} />,
    errorElement: <ErrorBoundary />,
  },
  // {
  //   path: "/chat",
  //   element: <Chat/>,
  //   errorElement: <ErrorBoundary/>
  // },
  {
    path: "/admin",
    element: <Admin />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
